import type { ValueOf } from './util/typeUtils';

export const USER_STATES = {
    AVAILABLE: 1,
    UNAVAILABLE: 2,
} as const;

export type USER_STATE = ValueOf<typeof USER_STATES>;

export const SYSTEM_USER = {
    id: 'system',
    role: 'system',
} as const;

/**
 * Languages the interface is actually rendered in.
 */
export const UI_LANGUAGES = {
    de: 'de',
    en: 'en',
} as const;

export type UI_LANGUAGE = ValueOf<typeof UI_LANGUAGES>;

/**
 * Values a user can pick as their language preference. `auto` is not a language — it defers to the
 * browser/system language and is resolved to a `UI_LANGUAGE` on the client.
 */
export const USER_LANGUAGE_SETTINGS = {
    auto: 'auto',
    de: 'de',
    en: 'en',
} as const;

export type USER_LANGUAGE_SETTING = ValueOf<typeof USER_LANGUAGE_SETTINGS>;

export const DEFAULT_USER_LANGUAGE_SETTING = USER_LANGUAGE_SETTINGS.de;

export const DEFAULT_UI_LANGUAGE = UI_LANGUAGES.de;

export const USER_STATUS_COLOR_MODES = {
    COLORFUL: 'COLORFUL',
    SYSTEM: 'SYSTEM',
} as const;

export type USER_STATUS_COLOR_MODE = ValueOf<typeof USER_STATUS_COLOR_MODES>;

export const DEFAULT_USER_STATUS_COLOR_MODE = USER_STATUS_COLOR_MODES.SYSTEM;

// keep in sync with schemaUserSettings (cpool-schemas) and DEFAULT_USER_SETTINGS
export type USER_SETTINGS = {
    language: USER_LANGUAGE_SETTING;
    statusColorMode: USER_STATUS_COLOR_MODE;
};

export const DEFAULT_USER_SETTINGS: USER_SETTINGS = {
    language: DEFAULT_USER_LANGUAGE_SETTING,
    statusColorMode: DEFAULT_USER_STATUS_COLOR_MODE,
};
